// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// Configuration is loaded from environment variables for security
// Fallback values are provided for backward compatibility
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBGuPTX9My5tGaM4Bww1GXPvEtCAXueHWY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "kisscoffee-3960a.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "kisscoffee-3960a",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "kisscoffee-3960a.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "428586615807",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:428586615807:web:633e237666b59133f75dca",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-28BGW9TNLK"
};

// Log configuration status
console.log('🔥 Firebase Configuration:');
console.log('- Using environment variables:', !!process.env.REACT_APP_FIREBASE_API_KEY);
console.log('- Project ID:', firebaseConfig.projectId);

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Enable offline persistence for better reliability on mobile
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('⚠️ Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.warn('⚠️ The current browser does not support persistence.');
  }
});

console.log('🔥 Firebase initialized successfully');

export { app, analytics, auth, db, storage };
